import { render, staticRenderFns } from "./ManualItemManage.vue?vue&type=template&id=0abdbd34&scoped=true"
import script from "./ManualItemManage.vue?vue&type=script&lang=js"
export * from "./ManualItemManage.vue?vue&type=script&lang=js"
import style0 from "./ManualItemManage.vue?vue&type=style&index=0&id=0abdbd34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abdbd34",
  null
  
)

export default component.exports